(function () {
    angular.module('tmx-app').factory('DayendService', ['tmxResource',
        function (tmxResource) {
            var Dayend = tmxResource("Dayend");

            Dayend.GetAllActiveProcesses = function(){
                return  Dayend.getByAction("GetAllActiveProcesses", true, 'get');
            }


            Dayend.GetDayendHistory = function(){
                return  Dayend.getByAction("GetDayendHistory", true, 'get');
            }

            return Dayend;
        }]);
})();